import axios from 'axios'

const state = {
  userProfile: {},
  status: '',
  authToken: localStorage.getItem('authToken') || '',
  errMessage: ''
}

const getters = {
  isAuthenticated: state => (state.authToken !== ''),
  authStatus: state => state.status,
  userProfile: state => state.userProfile,
  userInitials: state => state.userProfile ? state.userProfile.userFName.substring(0,1) + state.userProfile.userLName.substring(0,1) : "ZZ",
  authToken: state => state.authToken,
  isError: state => state.errMessage === '' ? false: true,
  errMessage: state => state.errMessage
}

const actions = {
  authenticateToken ({ commit }) {
    const token = localStorage.getItem('authToken')
    if (token) {
      const header = { 'x-auth': token }
      axios.get('/api/user', { headers: header })
      .then(response => {
        const retdata = { userProfile: response.data, authToken: token }
        commit('AUTHENTICATE_TOKEN', retdata)
      })
      .catch(() => {
        commit('USER_LOGOUT')
      })
    } else {
      commit('USER_LOGOUT')
    }
  },

  userLogin ({ commit, dispatch }, userData) {
    const header = { 'content-type': 'application/json' }
    axios.post('/api/authenticate', JSON.stringify(userData), { headers: header })
    .then((response) => {
      localStorage.setItem('authToken', response.data)
      dispatch('authenticateToken')
    })
    .catch(err => {
      commit('ERROR_DATA', err.response.data.err)
    })
  },

  userLogout ({ commit }) {
    commit('USER_LOGOUT')
  },

  createUser ({ commit }, userData) {
    commit('ERROR_DATA', "")
    const header = { 'content-type': 'application/json'}
    axios.post('/api/user', JSON.stringify(userData), { headers: header})
    .then(() => {
      commit('USER_SETUP')
    })
    .catch(err => {
      commit('ERROR_DATA', err.response.data)
    })
  }
}

const mutations = {
  AUTHENTICATE_TOKEN (state, payload) {
    state.userProfile = payload.userProfile
    state.authToken = payload.authToken
    state.status = 'success'
    state.errMessage = ''
  },

  USER_LOGOUT (state) {
    localStorage.removeItem('authToken')
    state.authToken = ''
    state.status = 'logout'
  },

  USER_SETUP (state) {
    state.status = 'Setup Done.  Check your email'
    state.errMessage = ''
  },

  ERROR_DATA (state, payload) {
    state.errMessage = payload
  }
}

export default {
  state, getters, actions, mutations
}
